import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      alert(error.message);
      return;
    }

    navigate("/profile");
  };

  // GOOGLE LOGIN
    const handleGoogleLogin = async () => {
      await supabase.auth.signInWithOAuth({
        provider: "google",
        options: {
          redirectTo: window.location.origin + "/profile",
        },
      });
    };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#faf9f6]">
      <div className="w-full max-w-md bg-white p-10 rounded-3xl shadow-xl">

        <h2 className="text-3xl text-center mb-6 text-[#8b6655]">Welcome Back</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            placeholder="Email Address"
            className="w-full p-3 border rounded-xl"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                className="w-full p-3 border rounded-xl pr-10"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>

          <div className="text-right">
        <Link
          to="/forgot-password"
          className="text-sm text-[#c19a82] hover:underline"
        >
          Forgot Password?
        </Link>
      </div>

          <button
            type="submit"
            className="w-full p-3 bg-[#e0be9c] rounded-xl"
          >
            Sign In
          </button>
        </form>

        {/* GOOGLE BUTTON */}
        <button
          onClick={handleGoogleLogin}
          className="w-full mt-4 p-3 border rounded-xl flex items-center justify-center gap-2 hover:bg-gray-50"
        >
          <img
            src="https://www.svgrepo.com/show/475656/google-color.svg"
            alt="google"
            className="w-5 h-5 bg-transparent"
          />
          Continue with Google
        </button>
        <p className="text-center mt-4 text-sm">
          Don’t have an account?{" "}
          <Link
            to="/register"
            className="text-[#C19A82] hover:underline font-medium"
          >
            Sign Up
          </Link>
        </p>

      </div>
    </div>
  );
};

export default Login;